var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0972 10.0379C25.4807 8.97101 24.3767 8.33204 23.1436 8.33204H16.3438C16.2558 8.32617 16.1677 8.32031 16.0796 8.32031C15.9916 8.32031 15.9034 8.32617 15.8154 8.33204H9.01564C7.78253 8.33204 6.67859 8.97101 6.06203 10.0379C5.44547 11.1048 5.44547 12.3769 6.06203 13.4438L13.126 25.6545C13.7426 26.7214 14.8466 27.3603 16.0796 27.3603C17.3127 27.3603 18.4167 26.7214 19.0333 25.6545L26.0972 13.4438C26.7138 12.3827 26.7138 11.1048 26.0972 10.0379ZM17.4008 24.7166C17.1248 25.1914 16.6316 25.4787 16.0796 25.4787C15.5276 25.4787 15.0345 25.1914 14.7584 24.7166L10.7831 17.8462L14.7584 10.9699C15.0051 10.542 15.422 10.2723 15.9034 10.2196H16.2558C16.7373 10.2723 17.1543 10.5478 17.4008 10.9699L21.3761 17.8403L17.4008 24.7166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenet);
export default __webpack_public_path__ + "static/media/tenet.e1acffdd6d7d1a4358a03c3c08cf0088.svg";
export { ForwardRef as ReactComponent };